import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  fieldGroup: {
    marginTop: 22,
  },
  fieldTitle: {
    display: "inline-block",
    marginLeft: 9,
    marginBottom: 10,
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    display: "inline-block",
  },
  addressCaption: {
    display: "inline-block",
    marginTop: 4,
    marginBottom: 11,
    marginLeft: theme.spacing(2),
    letterSpacing: "0.004em",
    color: "rgba(20, 30, 48, 0.5)",
  },
  addAltPhone: {
    color: "#2B59C3",
    display: "inline-block",
    marginBottom: 2,
  },
  addAltphoneText: {
    display: "inline-block",
  },
  btnGroup: {
    marginTop: theme.spacing(3),
  },
  submitBtn: {
    padding: theme.spacing(2),
    fontSize: "14px !important",
    color: "#ffff",
    backgroundColor: "#2B59C3",
    opacity: 1,
    "&:disabled": {
      opacity: 0.5,
      backgroundColor: "#2B59C3 !important",
    },
  },
  cancelBtn: {
    marginLeft: theme.spacing(2),
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    fontSize: "14px !important",
    color: theme.palette.primary.main,
  },
  fieldWrapper: {
    display: "flex",
  },
  cityField: {
    marginLeft: theme.spacing(1),
  },
  titleWrapper: {
    display: "flex",
  },
}));
